export const UserActionTypes = {
    SET_USER_ID: "SET_USER_ID",
    UPDATE_EMAIL : "SET_EMAIl",
    SEND_CONSENT: "SEND_CONSENT",
    SEND_EMAIL_CONSENT : "SEND_EMAIL_CONSENT",
    SET_USER_NAME: "SET_USER_NAME",
    SET_CONSENT: "SET_CONSENT",
    UNSUBSCRIBE: "UNSUBSCRIBE",
    SET_USER: "SET_USER",
    SET_HPR: "SET_HPR"
}